import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const NavigateUpButton = ({ node }) => {
  if (node.parent) {
    return (
      <div className="item">
        <Link to={`/nodes/${node.parent}`} className="ui labeled icon button">
          <i className="chevron left icon" />
          Parent
        </Link>
      </div>
    );
  }

  return null;
};

NavigateUpButton.propTypes = {
  node: PropTypes.shape({
    parent: PropTypes.number,
  }).isRequired,
};

export default NavigateUpButton;



// WEBPACK FOOTER //
// ./src/modules/catalog/components/NavigateUpButton.js